import type { ComponentPropsWithoutRef } from 'react'
import lock from '../../media/lock.png'
import { assetSrc } from '../../media/media-asset.util'
import { CircleIconContainer } from '../CircleIconContainer'
import { NoImageIcon } from '../icons/NoImageIcon'

const lockImage = assetSrc(lock)

export type Answer = {
  answerId: string
  imageUrl: string | null
}

type Props = {
  isDragging: boolean
  answer?: Answer
  handleShelfPhotoClick: (answer: Answer) => void
} & ComponentPropsWithoutRef<'button'>

export function GameCollectionShelfPhoto(props: Props) {
  const { isDragging, answer, handleShelfPhotoClick, ...rest } = props

  if (answer) {
    if (answer.imageUrl) {
      return (
        <CircleIconContainer
          className="shrink-0 grow-0 basis-16 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${answer.imageUrl})` }}
          onClick={(e) => {
            if (!isDragging) {
              handleShelfPhotoClick(answer)
              e.stopPropagation()
            }
          }}
          {...rest}
        />
      )
    } else {
      return (
        <CircleIconContainer
          className="shrink-0 grow-0 basis-16 bg-[rgba(246,246,246,1)]"
          onClick={(e) => {
            if (!isDragging) {
              handleShelfPhotoClick(answer)
              e.stopPropagation()
            }
          }}
          {...rest}
        >
          <NoImageIcon width={26} height={26} />
        </CircleIconContainer>
      )
    }
  } else {
    return (
      <CircleIconContainer className="pointer-events-none shrink-0 grow-0 basis-16 bg-[rgba(228,228,228,1)]" {...rest}>
        <img src={lockImage} width={26} height={26} />
      </CircleIconContainer>
    )
  }
}
